import { useSuperstarDetailContext } from './context';
import { RosterStatsDetailsV2 } from '@wwe-portal/ui/features/roster';
import { Slider } from '@wwe-portal/ui/components/range-slider';
import { CompareVFXConsumer } from './compare-vfx';
import { ShowcaseTarget } from '@wwe-portal/ui/components/showcase/primitives';
import {
  SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID,
  SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS,
} from '@wwe-portal/web/utils/superstar-details/constants';

export const SuperstarLevelConsumer = () => {
  const { currentLevel, changeLevel, gemStats, levelCap } =
    useSuperstarDetailContext((state) => ({
      currentLevel: state.currentStats.selectedLevel,
      changeLevel: state.changeLevel,
      gemStats: state.currentStats.gemStats,
      levelCap: state.currentStats.levelCap,
    }));

  const comparedGemStats = useSuperstarDetailContext(
    (state) => state.baseStats?.gemStats
  );

  return (
    <div>
      <div className="mb-1 flex items-center gap-2">
        <span className="drop-shadow-text-2 text-sm font-bold uppercase italic text-[#00BFFF]">
          Superstar level
        </span>
      </div>
      <ShowcaseTarget
        showCaseId={SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID}
        targetId={SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS.SUPERSTAR_LEVEL_SECTION}
      >
        <div>
          <CompareVFXConsumer>
            <ShowcaseTarget
              showCaseId={SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID}
              targetId={SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS.SLIDER}
            >
              <div className="border-back200 bg-back300 drop-shadow-card h-[46px] w-full rounded border-0 px-5 py-2.5 pr-5">
                <div className="flex">
                  <Slider
                    className="flex-1"
                    onValueChange={(nextValue) => {
                      const value = nextValue[0];
                      if (value != null) changeLevel(value);
                    }}
                    max={levelCap}
                    min={1}
                    step={1}
                    value={[currentLevel]}
                  />
                  <span className="drop-shadow-text ml-2 w-16 flex-shrink-0 flex-grow-0 text-center text-sm font-medium italic text-white">
                    <span className="text-yellow800">{currentLevel}</span> /{' '}
                    {levelCap}
                  </span>
                </div>
              </div>
            </ShowcaseTarget>
          </CompareVFXConsumer>
          <CompareVFXConsumer>
            <RosterStatsDetailsV2
              stats={{
                Black: {
                  value: gemStats?.Black ?? 0,
                  comparedValue: comparedGemStats?.Black,
                },
                Red: {
                  value: gemStats?.Red ?? 0,
                  comparedValue: comparedGemStats?.Red,
                },
                Blue: {
                  value: gemStats?.Blue ?? 0,
                  comparedValue: comparedGemStats?.Blue,
                },
                Green: {
                  value: gemStats?.Green ?? 0,
                  comparedValue: comparedGemStats?.Green,
                },
                Yellow: {
                  value: gemStats?.Yellow ?? 0,
                  comparedValue: comparedGemStats?.Yellow,
                },
                Purple: {
                  value: gemStats?.Purple ?? 0,
                  comparedValue: comparedGemStats?.Purple,
                },
              }}
            />
          </CompareVFXConsumer>
        </div>
      </ShowcaseTarget>
    </div>
  );
};
